var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M6.188 15.003h32.625M17.555 31.926v-11.65h-2.772m2.772 11.65h-2.772m2.772 0h2.813m3.431-11.65h2.742c3.755 0 4.227 4.718.544 5.244m0 0h-2.008m2.008 0c4.307.832 3.575 6.406-.877 6.406H23.8M12.905 6.75v1.028a2.399 2.399 0 0 0 2.398 2.4v0a2.399 2.399 0 0 0 2.4-2.4V6.75h9.595v1.028a2.399 2.399 0 0 0 2.399 2.4v0a2.399 2.399 0 0 0 2.399-2.4V6.75h1.919c2.65 0 4.797 2.16 4.797 4.825v21.85c0 2.665-2.148 4.825-4.797 4.825h-23.03c-2.65 0-4.797-2.16-4.797-4.825v-21.85c0-2.665 2.148-4.825 4.797-4.825h1.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture);
export default __webpack_public_path__ + "static/media/future.77872a32849893575cb7d0705b0a19b3.svg";
export { ForwardRef as ReactComponent };